import * as types from "../constants/auth";

// CONTACT US
export const apiLoginRequest = (data) => ({
  type: types.API_LOGIN_REQUEST,
  data,
});

export const apiLoginRequestSuccess = (response, action) => ({
  type: types.API_LOGIN_REQUEST_SUCCESS,
  response,
  action
});

export const apiLoginRequestFailed = (response) => ({
  type: types.API_LOGIN_REQUEST_FAILED,
  response,
});

//apiSignup
export const apiSignupRequest = (data) => ({
  type: types.API_SIGNUP_REQUEST,
  data,
});

export const apiSignupSuccess = (response) => ({
  type: types.API_SIGNUP_SUCCESS,
  response,
});

export const apiSignupFailed = (response) => ({
  type: types.API_SIGNUP_FAILED,
  response,
});


//refreshToken
export const refreshTokenRequest = (data) => ({
  type: types.REFRESH_TOKEN_REQUEST,
  data,
});

export const refreshTokenSuccess = (response) => ({
  type: types.REFRESH_TOKEN_SUCCESS,
  response,
});

export const refreshTokenFailed = (response) => ({
  type: types.REFRESH_TOKEN_FAILED,
  response,
});


// Logout
export const LogoutRequest = (data) => ({
  type: types.LOGOUT_REQUEST,
  data,
});



export const setUserInformation = (data) => ({
  type: types.SET_USER_INFORMATION,
  data,
});

export const clearToken = (token) => ({
  type: types.CLEAR_TOKEN,
  token,
});
export const logoutRequest = (data) => ({
  type: types.LOGOUT_REQUEST,
  data,
});

export const resetMsg = () => ({
  type: types.RESET_MSG,
});

// Request password reset
export const apiPasswordResetRequest = (email) => ({
  type: types.API_PASSWORD_RESET_REQUEST,
  email,
});

export const apiPasswordResetSuccess = (response) => ({
  type: types.API_PASSWORD_RESET_SUCCESS,
  response,
});

export const apiPasswordResetFailed = (response) => ({
  type: types.API_PASSWORD_RESET_FAILED,
  response,
});

// Password reset confirm
export const apiPasswordResetConfirmRequest = (data) => ({
  type: types.API_PASSWORD_RESET_CONFIRM_REQUEST,
  data,
});

export const apiPasswordResetConfirmSuccess = (response) => ({
  type: types.API_PASSWORD_RESET_CONFIRM_SUCCESS,
  response,
});

export const apiPasswordResetConfirmFailed = (response) => ({
  type: types.API_PASSWORD_RESET_CONFIRM_FAILED,
  response,
});

export const setLoginCallBack = (payload) => ({
  type: types.LOGIN_CALLBACK,
  payload,
});

export const handleSideBarNavigation = (payload, groupId, groupTitle) => ({
  type: types.HANDLE_SIDE_BAR_NAVIGATION,
  payload,
  groupId,
  groupTitle
});

export const handleSelectUser = (payload) => ({
  type: types.HANDLE_SELECT_USER,
  payload,
});

// getProfile
export const getProfileRequest = (data) => ({
  type: types.GET_PROFILE_REQUEST,
  data,
});

export const getProfileSuccess = (response) => ({
  type: types.GET_PROFILE_SUCCESS,
  response,
});

export const getProfileFailed = (response) => ({
  type: types.GET_PROFILE_FAILED,
  response,
});

// editProfile
export const editProfileRequest = (data) => ({
  type: types.EDIT_PROFILE_REQUEST,
  data,
});



export const editProfileSuccess = (response) => ({
  type: types.EDIT_PROFILE_SUCCESS,
  response,
});

export const editProfileFailed = (response) => ({
  type: types.EDIT_PROFILE_FAILED,
  response,
});

// setOpenChat
export const setOpenChat = (bool, course) => ({
  type: types.SET_OPEN_CHAT,
  bool,
  course
});



